import { jsx } from 'react/jsx-runtime';
import { Flex, useAccordion } from '@lemonade-hq/cdk';
import styled from 'styled-components';
import { FatSmallBottomChevronIcon } from '../Icons/Icons.esm.js';

function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  transition: transform 0.4s ease-in-out;\n  transform: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var ToggleArrowWrapper = styled(Flex).attrs({
    as: "span",
    alignItems: "center",
    justifyContent: "center"
})(_templateObject(), function(param) {
    var isOpen = param.isOpen;
    return isOpen && "rotate(180deg)";
});
var ToggleArrow = function() {
    var isOpen = useAccordion().isOpen;
    return /*#__PURE__*/ jsx(ToggleArrowWrapper, {
        isOpen: isOpen,
        children: /*#__PURE__*/ jsx(FatSmallBottomChevronIcon, {})
    });
};

export { ToggleArrow };
